import { render, staticRenderFns } from "./in_product_detail.vue?vue&type=template&id=bbc96a04&scoped=true&"
import script from "./in_product_detail.vue?vue&type=script&lang=js&"
export * from "./in_product_detail.vue?vue&type=script&lang=js&"
import style0 from "./in_product_detail.vue?vue&type=style&index=0&id=bbc96a04&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbc96a04",
  null
  
)

export default component.exports